import type { FC } from 'react'

import type { TIconProps } from 'types'

const ArrowDown: FC<TIconProps> = ({ className }) => (
  <svg className={className} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.6368 8.86321C17.2853 8.51174 16.7155 8.51174 16.364 8.86321L12.0004 13.2268L7.63679 8.86321C7.28532 8.51174 6.71547 8.51174 6.36399 8.86321C6.01252 9.21469 6.01252 9.78453 6.36399 10.136L11.364 15.136C11.7155 15.4875 12.2853 15.4875 12.6368 15.136L17.6368 10.136C17.9883 9.78453 17.9883 9.21469 17.6368 8.86321Z'
      fill='#19191A'
    />
  </svg>
)

export default ArrowDown
